import { render, staticRenderFns } from "./MedicalContentsHistory.vue?vue&type=template&id=619e5ae7&scoped=true&"
import script from "./MedicalContentsHistory.vue?vue&type=script&lang=js&"
export * from "./MedicalContentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentsHistory.vue?vue&type=style&index=0&id=619e5ae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619e5ae7",
  null
  
)

export default component.exports